export const validateEmail = (email, cb1 = () => {}, cb2 = () => {}) => {
  let condition = /^([a-zA-Z0-9_.-])+@([a-zA-Z0-9_.-])+\.([a-zA-Z])+([a-zA-Z])+/;
  if (email.length > 0 && !condition.test(email)) {
    cb1();
    return false;
  } else if (email.length === 0) {
    cb2();
    return false;
  }
  return true;
}

export const validatePassword = (password, cb1 = () => {}, cb2 = () => {}) => {
  if (password.length === 0) {
    cb1()
    return false;
  } else if (password.length < 6) {
    cb2();
    return false;
  }
  return true;
}

export const validatePassConfirm = (password, confirm, cb1 = () => {}, cb2 = () => {}) => {
  if (confirm === 0) {
    cb1()
    return false
  } else {
    if (password !== confirm) {
      cb2()
      return false
    }
  }
  return true
};